import { Button } from "@mui/material";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { showCustomToast } from "../Misc/CustomToast";
import DropDownComponentSorted from "../DropDownComponentSorted";

function AdminMobile(props) {
  //STATE
  const [isLoading, setIsLoading] = useState(false);

  const [projectedResidentialDischargeDate] = useState(props.projectedResidentialDischargeDate || "");

  const [recoveryRadio, setRecoveryRadio] = useState(props.recoveryRadio || "");

  const [googleReview, setGoogleReview] = useState(props.googleReview || "");

  //HANDLE FUNCTIONS

  const handleGoogleReview = (event) => {
    setGoogleReview(event);
  };

  const handleActiveRecoveryChange = (event) => {
    setRecoveryRadio(event);
  };

  // UPDATE FUNCTION

  const calculateDaysDifference = (seconds) => {
    const date1 = new Date(seconds * 1000); // Convertir les secondes en date
    const date2 = new Date(); // Date d'aujourd'hui
    const diffTime = date2 - date1; // Calculer la différence en millisecondes
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Convertir en jours
    return diffDays;
  };

  const updateAdminData = async (clientId) => {
    setIsLoading(true);
    try {
      const clientRef = doc(db, "clients", clientId);

      await updateDoc(clientRef, {
        recoveryRadio,
        googleReview,
      });
      setIsLoading(false);
      showCustomToast(`Admin datas successfully updated!`, "success");
    } catch (error) {
      console.error("Error updating Admin datas: ", error);
      setIsLoading(false);
      showCustomToast(`Error updating Admin datas: ${error}`, "error");
    }
  };

  //USEEFFECT
  useEffect(() => {
    setRecoveryRadio(props.recoveryRadio || "");
    setGoogleReview(props.googleReview || "");
  }, [props.googleReview, props.recoveryRadio]);

  return (
    <div className="tab-container-white-mobile2">
      <div className="tab-container-title">Administrator extra infos</div>

      <div className="tab-form-container"></div>

      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <div style={{ display: "flex", flexDirection: "column" }}>
          <div style={{ marginLeft: 15 }}>In active recovery?</div>
          <div style={{ width: 150 }}>
            <DropDownComponentSorted
              api="yesno"
              value={recoveryRadio}
              onChange={handleActiveRecoveryChange}
            />
          </div>

          {recoveryRadio === "Yes" && (
            <div style={{ marginLeft: 15, marginTop: 10, color: "red" }}>
              Total time in recovery:{" "}
              {calculateDaysDifference(
                projectedResidentialDischargeDate.seconds
              )}{" "}
              days
            </div>
          )}
        </div>
        <div style={{ width: 150 }}>
          <DropDownComponentSorted
            api="yesno"
            title="Google review done?"
            value={googleReview}
            onChange={handleGoogleReview}
          />
        </div>
      </div>

      <div className="button-container-form-gi-mobile">
        <Button
          variant="contained"
          onClick={() => updateAdminData(props.clientId)}
          style={
            isLoading
              ? {
                  backgroundColor: "red",
                  color: "white",
                  marginLeft: "15px",
                }
              : {
                  backgroundColor: "#1565C0",
                  color: "white",
                  marginLeft: "15px",
                }
          }
          disabled={isLoading}
          //   onClick={handlePostRecord}

          sx={{
            height: "40px",
            width: "220px",
            marginLeft: "0px",
            marginRight: "0px",
          }}
        >
          {isLoading ? "SAVING MODIFICATIONS..." : "SAVE MODIFICATIONS"}
        </Button>
      </div>
    </div>
  );
}

export default AdminMobile;
